import { jsx as _jsx } from "react/jsx-runtime";
import { formatPrice } from '@cronos-app/utils';
import { Fraction } from 'bi-fraction';
import { forwardRef, useMemo } from 'react';
import { BasicNumber } from './BasicNumber';
export const Price = forwardRef(({ prefix = '$', value: _value, price, ...props }, ref) => {
    const value = useMemo(() => {
        return _value && price
            ? formatPrice(Number(new Fraction(_value).mul(price).toFixed(10)), {
                min: 0,
            })
            : undefined;
    }, [_value, price]);
    return _jsx(BasicNumber, { ...props, value: value, prefix: prefix, ref: ref });
});
Price.displayName = 'Price';
